/* ============================================================================
   MUIZZ — tam ekran arama + son goruntulenenler

   - Header'daki arama ikonu bu paneli acar (Horizon'un kendi modali devre disi)
   - Panel asagidan yukari acilir, navbar'in altinda durur, asagi dogru kapanir
   - Yazarken Shopify'in predictive search ucuna sorar
   - Bos haldeyken son goruntulenen urunleri gosterir
   ========================================================================= */

(function () {
  'use strict';

  var STORAGE = 'muizz:recent';
  var LIMIT = 8;

  /* ------------------------------------------------------ son goruntulenenler */

  function recentRead() {
    try {
      var raw = localStorage.getItem(STORAGE);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function recentAdd(item) {
    if (!item || !item.url) return;
    var list = recentRead().filter(function (x) {
      return x.url !== item.url;
    });
    list.unshift(item);
    try {
      localStorage.setItem(STORAGE, JSON.stringify(list.slice(0, 12)));
    } catch (e) {
      /* gizli mod */
    }
  }

  window.MuizzRecent = { read: recentRead, add: recentAdd };

  /* ------------------------------------------------------------------ kart */

  function cardHtml(p) {
    var img = p.image
      ? '<img src="' + p.image + '" alt="" loading="lazy">'
      : '<span class="mz-search__ph"></span>';
    return (
      '<a class="mz-search__card" href="' + p.url + '">' +
      '<span class="mz-search__thumb">' + img + '</span>' +
      '<span class="mz-search__meta">' +
      '<span class="mz-search__name">' + p.title + '</span>' +
      (p.price ? '<span class="mz-search__price">' + p.price + '</span>' : '') +
      '</span></a>'
    );
  }

  /* ---------------------------------------------------------------- panel */

  function init() {
    var panel = document.getElementById('mz-search');
    if (!panel) return;

    var input = panel.querySelector('[data-mz-search-input]');
    var results = panel.querySelector('[data-mz-search-results]');
    var heading = panel.querySelector('[data-mz-search-heading]');
    var empty = panel.querySelector('[data-mz-search-empty]');
    var closeBtn = panel.querySelector('[data-mz-search-close]');

    var open = false;
    var controller = null;
    var debounce = null;
    var topTicking = false;

    /* Panelin ust kenari header'in GERCEK alt kenarina oturur.
       Onceden CSS degiskenleriyle hesaplaniyordu ama o degerler sayfa
       yuklenirken bir kez yaziliyor; kullanici asagi kaydirinca header
       kuculuyor ve panel dogru yere oturmuyordu. Artik olculuyor. */
    function syncTop() {
      // #header-group 'display: contents' oldugu icin kutusu yok (0 olculuyor).
      // Gercek olculebilir eleman <header-component>: sayfa ustundeyken duyuru
      // cubugu dahil ~108px, kaydirinca ~65px.
      var candidates = [
        document.querySelector('header-component'),
        document.getElementById('header-group'),
        document.querySelector('.header-section'),
      ];

      var bottom = 0;
      candidates.forEach(function (el) {
        if (!el) return;
        var rect = el.getBoundingClientRect();
        if (rect.height > 0) bottom = Math.max(bottom, rect.bottom);
      });

      panel.style.setProperty('--mz-search-top', Math.max(0, Math.round(bottom)) + 'px');
    }

    function scheduleSyncTop() {
      if (topTicking) return;
      topTicking = true;
      requestAnimationFrame(function () {
        topTicking = false;
        if (open) syncTop();
      });
    }

    function showRecent() {
      var list = recentRead().slice(0, LIMIT);
      heading.textContent = 'Son görüntülediklerin';
      empty.hidden = true;
      results.innerHTML = list.length
        ? list.map(cardHtml).join('')
        : '<p class="mz-search__hint">Henüz ürün görüntülemedin. Aramaya başla.</p>';
    }

    function openPanel() {
      if (open) return;
      open = true;
      panel.hidden = false;
      syncTop();
      // reflow: gecis calissin
      void panel.offsetWidth;
      panel.classList.add('is-open');
      document.documentElement.classList.add('mz-search-open');
      showRecent();
      setTimeout(function () {
        input.focus();
        syncTop();
      }, 320);
    }

    function closePanel() {
      if (!open) return;
      open = false;
      panel.classList.remove('is-open');
      document.documentElement.classList.remove('mz-search-open');
      setTimeout(function () {
        if (!open) panel.hidden = true;
      }, 620);
    }

    async function search(q) {
      if (controller) controller.abort();
      controller = new AbortController();

      var url =
        '/search/suggest.json?q=' +
        encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=' + LIMIT +
        '&resources[options][unavailable_products]=last';

      try {
        var res = await fetch(url, { signal: controller.signal });
        if (!res.ok) throw new Error('arama basarisiz');
        var data = await res.json();
        var products = ((data.resources || {}).results || {}).products || [];

        heading.textContent = products.length
          ? products.length + ' sonuç'
          : 'Sonuç yok';

        results.innerHTML = products
          .map(function (p) {
            return cardHtml({
              url: p.url,
              title: p.title,
              image: p.featured_image ? p.featured_image.url : null,
              price: p.price ? p.price : null,
            });
          })
          .join('');

        empty.hidden = products.length > 0;
      } catch (e) {
        if (e.name !== 'AbortError') {
          heading.textContent = 'Arama şu an yanıt vermiyor';
        }
      }
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(debounce);
      if (q.length < 2) {
        showRecent();
        return;
      }
      debounce = setTimeout(function () {
        search(q);
      }, 220);
    });

    if (closeBtn) closeBtn.addEventListener('click', closePanel);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && open) closePanel();
    });

    // Header yuksekligi degisirse (kaydirma, kucuk ekran, duyuru cubugu
    // kapatilmasi) panel takip etsin
    window.addEventListener('resize', scheduleSyncTop, { passive: true });
    window.addEventListener('scroll', scheduleSyncTop, { passive: true });
    var wrapper = document.querySelector('.page-wrapper');
    if (wrapper) wrapper.addEventListener('scroll', scheduleSyncTop, { passive: true });

    if (typeof ResizeObserver === 'function') {
      var headerEl = document.querySelector('header-component');
      if (headerEl) new ResizeObserver(scheduleSyncTop).observe(headerEl);
    }

    // Panel disina tiklayinca kapat
    panel.addEventListener('click', function (e) {
      if (e.target === panel) closePanel();
    });

    // Horizon'un arama tetikleyicilerini bu panele yonlendir
    document.addEventListener(
      'click',
      function (e) {
        // Horizon arama ikonu <search-button> icinde duruyor ve tiklama
        // Horizon'un modalini cagiriyor; o modal kaldirildigi icin hicbir sey
        // olmuyordu. Tetikleyici listesine search-button eklendi.
        var trigger = e.target.closest(
          'search-button, [data-mz-search-open], .header-actions__search, ' +
            '[ref="searchButton"], a[href$="/search"], .header__icon--search'
        );
        if (!trigger) return;
        // Arama SONUC sayfasindaki baglantilar normal calissin
        if (trigger.closest('#mz-search')) return;
        e.preventDefault();
        e.stopPropagation();
        openPanel();
      },
      true
    );

    window.MuizzSearch = { open: openPanel, close: closePanel };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
